import React from 'react';
import { SettingsManager } from '../SettingsManager/SettingsManager';
import { useSettings } from '../../hooks/queries/useSettings';
import { useProfiles } from '../../hooks/queries/useProfiles';
import { useDashboardActions } from '../Dashboard/useDashboardActions';
import { GamePageWrapper } from '../GameLayout';
import { CLOCK_THEMES } from '../../styles/clockThemes';
import styles from './SettingsPage.module.scss';

export const SettingsPage: React.FC = () => {
  const { settings, loading: settingsLoading, updateSettings } = useSettings();
  const { profiles, loading: profilesLoading, refetch: refetchProfiles } = useProfiles();

  const { 
    saveSettings 
  } = useDashboardActions(refetchProfiles, updateSettings);

  // Get current theme
  const currentTheme = CLOCK_THEMES[settings?.clockThemeId || 'playful_focus'] || CLOCK_THEMES['playful_focus'];

  if (settingsLoading || profilesLoading || !settings) {
    return (
      <GamePageWrapper title="⚙️ Settings">
        <div className={styles.loading}>Loading Settings...</div>
      </GamePageWrapper>
    );
  }

  return (
    <GamePageWrapper title="⚙️ Settings">
      <div className={styles.content}>
        <SettingsManager
          settings={settings}
          profiles={profiles}
          onSettingsChange={saveSettings}
          themeColors={{
            // The Settings page chrome sits on a fixed cream background, so its
            // text must stay dark/readable regardless of the selected CLOCK theme
            // (a dark theme's light text would otherwise vanish here). Only the
            // accent — used for the selected-card highlight — follows the theme.
            textColor: '#1F1F22',
            accentColor: currentTheme.colors.accentColor,
            secondaryText: 'rgba(31, 31, 34, 0.65)',
          }}
        />
      </div>
    </GamePageWrapper>
  );
};
